import { Link } from "react-router-dom";
import TriskelionMark from "./TriskelionMark";

export default function Footer() {
  return (
    <footer className="border-t border-stone-200 bg-[#FAF8F4]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="V.I.A logo" className="h-10 w-10 object-cover" />
              <span className="font-display text-2xl font-black uppercase tracking-wide text-stone-950">V.I.A</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-stone-500">
              Vannin Independent Apparel — heritage streetwear from the Isle of Man. Every order personally handled by us.
            </p>
          </div>
          <div className="flex gap-16 md:justify-center">
            <div>
              <p className="via-label">Shop</p>
              <div className="flex flex-col gap-2 text-sm text-stone-700">
                <Link to="/shop" className="hover:text-[#E52E39]">All pieces</Link>
                <Link to="/shop" className="hover:text-[#E52E39]">T-Shirts</Link>
                <Link to="/shop" className="hover:text-[#E52E39]">Hoodies</Link>
                <Link to="/shop" className="hover:text-[#E52E39]">Outerwear</Link>
              </div>
            </div>
            <div>
              <p className="via-label">Company</p>
              <div className="flex flex-col gap-2 text-sm text-stone-700">
                <span className="text-stone-400">Douglas, Isle of Man</span>
                <span className="text-stone-400">54.2361° N, 4.5481° W</span>
              </div>
            </div>
          </div>
          <div className="md:text-right">
            <p className="via-label">Delivery & Payments</p>
            <p className="text-sm leading-relaxed text-stone-500">
              £3.95 UK delivery, free over £50. Estimated delivery times are shown on every piece. Secure card payments
              via Stripe.
            </p>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-stone-200 pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-stone-400 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} V.I.A — Vannin Independent Apparel</span>
          <span>Ellan Vannin • Three Legs of Man</span>
        </div>
      </div>
    </footer>
  );
}
